module.exports = __webpack_public_path__ + "img/supplier-form-bg.dcc4b15.webp";